/* eslint-disable react/sort-comp */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';

import AccountLoginForm from '../forms/accountLoginForm';

const AccountLoginView = props => {
  const toEventList = (e) => {
    e.preventDefault();
    props.history.push('/');
  };

  const { translate } = props;

  return (
    <Fragment>
      <Helmet>
        <title>
          {translate('login.page.headername')} | {translate('common.siteTitle')}
        </title>
      </Helmet>
      <Container>
        <TopLeftLogo onClick={(e) => toEventList(e)} />
        <BackButton onClick={(e) => toEventList(e)}>
          <WhiteLeftArrow />{translate('back')}
        </BackButton>
        <Body>
          <CurvedBox>
            <AccountLoginForm />
          </CurvedBox>
        </Body>
      </Container>
    </Fragment>
  );
};

const Container = styled.div`
  background-image: url('/img/event/event-signup-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
   @media (max-width: 768px) {
    text-align: center;
  }
`;

const Body = styled.div`
  text-align: center;
`;

const CurvedBox = styled.div`
  background-color: #FFFFFF;
  border-radius: 18px;
  min-height: 100px;
  display: inline-block;
  @media (min-width: 768px) {
    width: 469px;
    margin-top: 60px;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 25px;
  }
`;
  // @media (min-width: 768px) {
  //   top: 20px;
  //   left: 200px;
  //   position: absolute;
  // }
const TopLeftLogo = styled.button`
  background-image: url('/img/cms/create-event-logo.png');
  background-repeat: no-repeat;
  height: 36px;
  width: 170px;
  background-size: 100%;
  display: inline-block;
  border: none;
  background-color: transparent;
  position: absolute;
  top: 20px;
  left: 200px;
  
   @media (max-width: 1185px) {
    left: 100px;
  }
  @media (max-width: 991px) {
    left: 2rem;
  }
@media (max-width: 851px) {
  top: 0.1em;
  left: 1em;
} 
`;
  // @media (min-width: 768px) {
  //   top: 110px;
  //   left: 200px;
  //   position: absolute;
  // }
  // @media (max-width: 768px) {
  //   display: none;
  // }
const BackButton = styled.button`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
  color: #FFFFFF;

  height: 20px;
  width: 70px;
  font-size: 17px;
  border: none;
  background-color: transparent;
  position: absolute;
  top: 110px;
  left: 200px;

    @media (max-width: 1185px) {
    left: 100px;
  }
  @media (max-width: 991px) {
    left: 4em;
  }
  @media (max-width:768px) {
    display: none;
  }
`;

const WhiteLeftArrow = styled.div`
  background-image: url('/img/icons/white-left-angle.png');
  background-repeat: no-repeat;
  background-size: 100%;
  height: 13px;
  width: 8px;
  display: inline-block;
  margin-right: 10px;
`;

export default compose(
  withLocalize,
  withRouter,
  connect(({ user }) => ({ user }))
)(AccountLoginView);



// WEBPACK FOOTER //
// ./src/components/login/accountLogin.js